// Return precision props, either from props if given, or from the value itself
export function getPrecision(props) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.';
  var decimalPrecision = props.decimalPrecision,
    significantDigits = props.significantDigits,
    value = props.value;
  if (decimalPrecision != null) return {
    decimalPrecision: decimalPrecision
  };
  if (significantDigits != null) return {
    significantDigits: significantDigits
  };
  if (value != null) {
    var precisionFromInput = getDecimals(value.toString(), separator).length;
    if (precisionFromInput > 0) return {
      decimalPrecision: precisionFromInput
    };
  }
  return {};
}

// Return the portion of the given string that follows the decimal separator
function getDecimals(string, separator) {
  var match = string.match(new RegExp("\\".concat(separator, "(\\d+)")));
  return match ? match[1] : '';
}
export default getPrecision;